"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { createContext, useCallback, useContext } from "react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, } from "./alert-dialog";
const ConfirmContext = createContext(undefined);
export function ConfirmProvider({ children }) {
    const invokingControl = React.useRef(null);
    const resolveRef = React.useRef(null);
    const [isOpen, setIsOpen] = React.useState(false);
    const [options, setOptions] = React.useState({});
    const settle = useCallback((value) => {
        const resolver = resolveRef.current;
        resolveRef.current = null;
        setIsOpen(false);
        resolver?.(value);
    }, []);
    const confirm = useCallback((options) => {
        const activeElement = document.activeElement;
        const menuTriggerId = activeElement
            ?.closest('[role="menu"]')
            ?.getAttribute("aria-labelledby");
        const menuTrigger = menuTriggerId
            ? document.getElementById(menuTriggerId)
            : null;
        invokingControl.current =
            menuTrigger instanceof HTMLElement
                ? menuTrigger
                : activeElement instanceof HTMLElement
                    ? activeElement
                    : null;
        setOptions(options);
        setIsOpen(true);
        return new Promise((res) => {
            resolveRef.current = res;
        });
    }, []);
    const handleConfirm = useCallback(() => {
        settle(true);
    }, [settle]);
    const handleCancel = useCallback(() => {
        settle(false);
    }, [settle]);
    return (_jsxs(ConfirmContext.Provider, { value: { confirm }, children: [children, _jsx(AlertDialog, { open: isOpen, onOpenChange: (open) => {
                    if (!open && resolveRef.current)
                        handleCancel();
                }, children: _jsxs(AlertDialogContent, { onCloseAutoFocus: (event) => {
                        if (invokingControl.current?.isConnected) {
                            event.preventDefault();
                            invokingControl.current.focus({ preventScroll: true });
                        }
                    }, children: [_jsxs(AlertDialogHeader, { children: [_jsx(AlertDialogTitle, { children: options.title || "Confirm Action" }), _jsx(AlertDialogDescription, { children: options.description || "Are you sure you want to continue?" })] }), _jsxs(AlertDialogFooter, { children: [_jsx(AlertDialogCancel, { onClick: handleCancel, children: options.cancelText || "Cancel" }), _jsx(AlertDialogAction, { onClick: handleConfirm, children: options.confirmText || "Continue" })] })] }) })] }));
}
export function useConfirm() {
    const context = useContext(ConfirmContext);
    if (!context) {
        throw new Error("useConfirm must be used within a ConfirmProvider");
    }
    return context.confirm;
}
//# sourceMappingURL=confirm-dialog.js.map